import { FUND_ENTITY_FUNCTIONAL_TYPES } from "features/entities/FundEntityConstants";
import { EntityFunctionalTypeEnum } from "gen/model/entityFunctionalTypeEnum";
import { useTranslation } from "react-i18next";
import { FormSelect } from "shared/components/input/select/Select";
import { SelectElement } from "shared/components/input/select/SelectOption";

export const FunctionalTypeFormSelect: React.FC<{
  isInvestorEntity: boolean;
  isFundFamilyRelated: boolean;
}> = ({ isInvestorEntity, isFundFamilyRelated }) => {
  const { t } = useTranslation(["entity", "enums"]);

  // Only allowing creation of fund entities under the fund family page for now.
  // TODO: adjust after designs are completed.
  const entityFunctionalTypes = isInvestorEntity
    ? [EntityFunctionalTypeEnum.investor]
    : isFundFamilyRelated
      ? FUND_ENTITY_FUNCTIONAL_TYPES
      : [
          EntityFunctionalTypeEnum.alternative_investment_vehicle,
          EntityFunctionalTypeEnum.general_partner,
          EntityFunctionalTypeEnum.special_limited_partner,
          EntityFunctionalTypeEnum.general_partner_and_special_limited_partner,
          EntityFunctionalTypeEnum.management_company,
          EntityFunctionalTypeEnum.lender,
        ];
  const entityFunctionalTypeElements = (
    entityFunctionalTypes as EntityFunctionalTypeEnum[]
  ).map<SelectElement>((entityType) => ({
    value: entityType,
    rich_value: t(`enums:EntityFunctionalTypeEnum.${entityType}`),
  }));

  return (
    <FormSelect
      name="functional_type"
      title={t("entity:functionalType")}
      elements={entityFunctionalTypeElements}
      defaultValue={isInvestorEntity ? "investor" : undefined}
    />
  );
};
